export const TABS = Object.freeze({
  PENDING: 'pending',
  AWAITING_INVITE: 'awaiting_invite',
  INVITE_SENT: 'invite_sent',
  ACTIVE: 'active',
  DISCHARGED: 'discharged',
  DECLINED: 'declined',
  UNKNOWN: 'unknown'
})
